import styles from "./DataGridMobileView.module.scss";

interface Props {
    headerColumns: Array<string>;
    data: object;
    leftCells: Array<any>;
    rightCells: Array<any>;
    pageSize?: number;
}

const DatagridMobileView = ({ headerColumns, data, leftCells, rightCells }: Props) => {
    return (
        <div className={styles.dataGridMobileView}>
            {headerColumns.length > 0 && (
                <div className={styles.header}>
                    {headerColumns.map((el, idx) => (
                        <div className={styles.title} key={idx}>
                            {el}
                        </div>
                    ))}
                </div>
            )}
            <div className={styles.body}>
                <div className={styles.wrapper}>
                    {leftCells.map((el, idx) => (
                        <div className={styles.wrapCol} key={idx}>
                            {el.renderCell(data)}
                        </div>
                    ))}
                </div>
                <div className={styles.rightwrapper}>
                    {rightCells.map((el, idx) => (
                        <div className={styles.wrapCol} key={idx}>
                            {el.renderCell(data)}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DatagridMobileView;
